var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"brand-logo",attrs:{"to":"/"}},[_c('b-img',{attrs:{"src":_vm.appLogoImage,"alt":"logo"}}),_c('h2',{staticClass:"brand-text text-primary ml-1 mb-0"},[_vm._v(" "+_vm._s(_vm.appName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }